<template>
  <div>
    <d-header
      fluid
      :breadcrumbs="false"
      :class="{
        'pt-5': $laravel.user.is_owner_contact || $laravel.user.owner_id,
      }"
    >
      <h1 class="title is-4">
        <d-previous-btn :path="'/owners/' + model.id + '/owner-businesses'" />
        {{ $t("new_owner_business") }}
      </h1>
    </d-header>

    <v-form
      ref="form"
      action="create"
      :owner_id="model.id"
    />
  </div>
</template>

<script>
import form from "./_form.vue";
export default {
  metaInfo() {
    return {
      title: this.$t("new_owner_business"),
    };
  },
  components: {
    "v-form": form,
  },
  props: {
    model: {
      default: null,
      type: Object,
    },
  },
  methods: {
    submitForm() {
      this.$refs.form.$refs.form.submit();
    },
  },
};
</script>
